import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';
import { DialogChildButton, NewDialog } from 'components';

export default function MainModel(props) {
  const { children, action, graph, title, disabled, initFilter, isPopup = false } = props;
  const init = { ...initFilter };

  const [startFetch, setStartFetch] = useState(!isPopup);
  const [flag, setFlag] = useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [total, setTotal] = useState(0);
  const [result, setResult] = useState([]);
  const [filter, setFilter] = useState(init);
  const [selectable, setSelectable] = useState(false);
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => {
    if (!disabled) {
      setOpen(true);
      setStartFetch(true);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const [getData, { loading }] = useLazyQuery(graph.list.query, {
    context: {
      serviceName: graph.list.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const clearFilter = () => setFilter(init);

  const refresh = () => {
    setPage(1);
    setResult([]);
    setFlag(!flag);
  };

  const handleSetFilter = (filter) => {
    setPage(1);
    setResult([]);
    setFilter((prev) => ({ ...prev, ...filter }));
  };

  const handleData = async (paginate) => {
    try {
      const { data, error } = await getData({
        variables: {
          ...filter,
          page,
          limit,
        },
      });
      if (!isEmptyObject(data) && !error) {
        const res = data[graph.list.name]?.import_error_records;
        setTotal(res?.total);
        paginate ? setResult((prevData) => prevData.concat(res?.data)) : setResult(res?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    startFetch && handleData(page > 1);
  }, [startFetch, page, filter, flag]);

  useEffect(() => {
    initFilter && setFilter(initFilter);
  }, [initFilter]);

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...props,
        page,
        limit,
        total,
        result,
        filter,
        loading,
        setPage,
        isPopup,
        onClose,
        selectable,
        clearFilter,
        setSelectable,
        setStartFetch,
        refetch: refresh,
        setFilter: handleSetFilter,
      });
    }
    return child;
  });

  if (isPopup) {
    return (
      <>
        <DialogChildButton title={title} onClick={onOpen} children={action} />
        <NewDialog label={title} open={open} onClose={onClose}>
          {childrenWithProps}
        </NewDialog>
      </>
    );
  }

  return childrenWithProps;
}
